import { Injectable } from '@angular/core';
import { RokezzzPlatformService } from 'src/app/rokezzz/platform/services/platform.service';
import { RokezzzWindowService } from 'src/app/rokezzz/window/services/window.service';

@Injectable({
    providedIn: 'root'
})
export class RokezzzCookieService {
    private readonly dayTime: number = 24 * 60 * 60 * 1000;

    private document: Document;

    public constructor(
        private readonly rokezzzWindowService: RokezzzWindowService,
        private readonly rokezzzPlatformService: RokezzzPlatformService,
    ) {
        this.document = this.rokezzzWindowService.getDocument();
    }

    public set(name: string, value: string, days: number): void {
        if (this.rokezzzPlatformService.isPlatformBrowser()) {
            const date: Date = new Date();

            date.setTime(date.getTime() + (days * this.dayTime));
            this.document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
        }
    }

    public get(name: string): string {
        if (this.rokezzzPlatformService.isPlatformBrowser()) {
            let ca: string[] = this.document.cookie.split(';'),
                caLen: number = ca.length,
                cookieName: string = `${name}=`,
                c: string;

            for (let i = 0; i < caLen; i += 1) {
                c = ca[i].replace(/^\s+/g, '');

                if (c.indexOf(cookieName) === 0) {
                    return c.substring(cookieName.length, c.length);
                }
            }
        }

        return '';
    }

    public delete(name: string): void {
        if (this.rokezzzPlatformService.isPlatformBrowser()) {
            this.set(name, '', -1);
        }
    }

    public getAll(): string[] {
        if (this.rokezzzPlatformService.isPlatformBrowser()) {
            return this.document.cookie.split(';');
        }

        return [];
    }
}
